import { create } from "zustand";
import { persist } from "zustand/middleware";
import { COMPANY_STORE_ID } from "../../components/components.constants";

export const useStoreInformation = create()(
  persist(
    (set) => ({
      selectedStoreId: null,
      selectedStoreNumber: null,
      availableStores: [],
      
      setStore: (storeId, storeNumber) => set({ 
        selectedStoreId: storeId, 
        selectedStoreNumber: storeNumber 
      }),
      setAvailableStores: (stores) => set({ availableStores: stores }),
      reset: () => set({ 
        selectedStoreId: null, 
        selectedStoreNumber: null, 
        availableStores: [] 
      }),
    }),
    {
      name: "store-information",
    }
  )
);

export const useActiveStore = create()(
  persist(
    (set) => ({
      storeId: COMPANY_STORE_ID.STORE_ID,
      setStoreId: (storeId) => set({ storeId }),
      reset: () => set({ storeId: COMPANY_STORE_ID.STORE_ID }),
    }),
    {
      name: "active-store",
    }
  )
);

